// Hero section — the full-bleed opening header with the dashed-cube Scene
// behind the headline. Mounted by Landing.tsx. Scene no longer takes a
// sheetRef: it used to ride down and park beside "Two kinds of work" as the
// page scrolled, but that assembly now belongs entirely to Assembly.tsx's
// set piece further down the page, so Scene has nothing left to clamp
// against — it just floats in place and fades out as the hero scrolls away.
import Scene from '../Scene';
import './Hero.css';

const Arrow = () => (
  <svg className="arrow" width="14" height="10" viewBox="0 0 14 10" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M1 5h11M8.5 1.5 12 5l-3.5 3.5" />
  </svg>
);

export function Hero() {
  return (
    <header className="hero hero--bleed" data-mood="hero">
      <div className="hero__world" aria-hidden="true">
        <Scene />
      </div>
      <div className="wrap hero__grid">
        <div className="hero__copy">
          <h1>We build software, then stay to keep it running.</h1>
          <p className="lede">
            A small software company in Singapore. We make products of our own, and we
            build the systems other businesses run on every day.
          </p>
          <div className="hero__cta">
            <a className="btn" href="mailto:hello@blockworks.dev">
              Get in touch <Arrow />
            </a>
            <span className="hero__note">hello@blockworks.dev</span>
          </div>
        </div>
      </div>
    </header>
  );
}
